<template>
    <div v-observe-visibility="visibilityChanged" style="padding: 8px;height:100%;width:100%">
        <Row v-show="rawData.data.length > 1">
            <Col span="12">
                <LineChart v-bind="qolQ1ChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ2AChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ2BChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ3AChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ3BChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ4AChartData" style="min-height:195px; max-height:250px;" />
            </Col>
            <Col span="12">
                <LineChart v-bind="qolQ4BChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ5ChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ6AChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ6BChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ6CChartData" style="min-height:130px; max-height:160px;" />
                <LineChart v-bind="qolQ7ChartData" style="min-height:195px; max-height:250px;" />
            </Col>
        </Row>
        <Row v-show="rawData.data.length <= 1">
            There is insufficient data to show meaningful charts. Once there is at least two sessions worth of data available, the charts will be shown.
        </Row>

        <!-- <apexchart ref="mychart" width="500" type="line" :options="chartOptions" :series="series"></apexchart> -->

    </div>
</template>

<script>
// const {CONFIG} = require('@/js/bntx-config')
//var axios = require("axios");
var _ = require('lodash');
// import AnalyticsMgr from '@/js/AnalyticsManager.js';

// import { Utils } from "chart.js";

const {itBnTx} = require('@/js/itBnTx')

import { LineChart, /*BarChart,*/ /*useBarChart*/ } from "vue-chart-3";
// import { ref, computed, /*defineComponent*/ } from "@vue/composition-api";
// import { shuffle } from "lodash";

// import {DateTime } from "luxon"

// import {enUS} from 'date-fns/locale';
// import 'chartjs-adapter-moment';
import 'chartjs-adapter-luxon';


const MAGIC_NULL_VAL = 0.25


export default {
    // name: 'su-pharmacy-management',
    name: 'report-insights-hit6',
    props: {

        patientID: {
            type: Number,
            required: false,
            default: 1
        },

    },
    components: {
        LineChart,
        // BarChart,
    },

    // setup() {
    //     const data = ref([30, 40, 60, 70, 5]);
    //     const legendTop = ref(true);
    //     const imgData = ref(null);

    //     const options = computed(() => ({
    //     scales: {
    //         y: {
    //         beginAtZero: true,
    //         },
    //     },
    //     plugins: {
    //         zoom: {
    //         zoom: {
    //             wheel: {
    //             enabled: true,
    //             },
    //             pinch: {
    //             enabled: true,
    //             },
    //             mode: "xy",
    //         },
    //         },
    //     },
    //     }));

    //     const chartData = computed(() => ({
    //     labels: ["Paris", "Nîmes", "Toulon", "Perpignan", "Autre"],
    //     datasets: [
    //         {
    //         data: data.value,
    //         backgroundColor: [
    //             "#77CEFF",
    //             "#0079AF",
    //             "#123E6B",
    //             "#97B0C4",
    //             "#A5C8ED",
    //         ],
    //         },
    //     ],
    //     }));

    //     const { barChartProps, barChartRef } = useBarChart({
    //     chartData,
    //     options,
    //     });

    //     function shuffleData() {
    //     data.value = shuffle(data.value);
    //     legendTop.value = !legendTop.value;
    //     imgData.value = barChartRef.value.chartInstance.toBase64Image();
    //     //   barChartRef.value.chartInstance.resetZoom();
    //     }

    //     function zoom() {
    //     barChartRef.value.chartInstance.zoom(1.01);
    //     }

    //     return { shuffleData, barChartProps, barChartRef, imgData, zoom };
    // },


    created () {


    },

    destroyed() {

    },

    mounted() {

    },


    data () {
            // const DATA_COUNT = 7;
            // const NUMBER_CFG = {count: DATA_COUNT, min: 0, max: 100};

            return {
                // following are cached, and loaded as soon as we are visible, so save on unnecessary API calls. Sometimes too dynamic is not good.
                toLoadOnShowUI_patientID: null,

                chartOptions: {
                    chart: {
                        id: 'vuechart-example'
                    },
                    stroke: {
                        curve: 'smooth'
                    },
                    xaxis: {
                        type: 'datetime',
                        categories: [],
                        labels: {
                            format: "d MMM"
                        }
                    }
                },
                series: [{
                    name: 'series-1',
                    data: []
                    }],


                rawData : {
                        data: [
                            {
                                "choiceAnswers": [
                                    {
                                        "identifier": "q1",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q2a",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q2b",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q3a",
                                        "answer": 1
                                    },
                                    {
                                        "identifier": "q3b",
                                        "answer": 4
                                    },
                                    {
                                        "identifier": "q4a",
                                        "answer": 4
                                    },
                                    {
                                        "identifier": "q4b",
                                        "answer": 5
                                    },
                                    {
                                        "identifier": "q5",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q6a",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q6b",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q6c",
                                        "answer": 1
                                    },
                                    {
                                        "identifier": "q7",
                                        "answer": 2
                                    }
                                ],
                                "source" : 2,
                                "timestamp": 1599443921000
                            },
                            {
                                "choiceAnswers": [
                                    {
                                        "identifier": "q1",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q2a",
                                        "answer": 1
                                    },
                                    {
                                        "identifier": "q2b",
                                        "answer": 1
                                    },
                                    {
                                        "identifier": "q3a",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q3b",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q4a",
                                        "answer": null
                                    },
                                    {
                                        "identifier": "q4b",
                                        "answer": 4
                                    },
                                    {
                                        "identifier": "q5",
                                        "answer": null
                                    },
                                    {
                                        "identifier": "q6a",
                                        "answer": null
                                    },
                                    {
                                        "identifier": "q6b",
                                        "answer": null
                                    },
                                    {
                                        "identifier": "q6c",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q7",
                                        "answer": 2
                                    }
                                ],
                                "source" : 1,
                                "timestamp": 1587520853000
                            },
                            {
                                "choiceAnswers": [
                                    {
                                        "identifier": "q1",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q2a",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q2b",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q3a",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q3b",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q4a",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q4b",
                                        "answer": 5
                                    },
                                    {
                                        "identifier": "q5",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q6a",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q6b",
                                        "answer": 3
                                    },
                                    {
                                        "identifier": "q6c",
                                        "answer": 2
                                    },
                                    {
                                        "identifier": "q7",
                                        "answer": 3
                                    }
                                ],
                                "source" : 2,
                                "timestamp": 1578016853000
                            }
                        ]
                },

                barChartProps2 : {
                    chartData : {
                        // labels: ["Paris", "Nîmes", "Toulon", "Perpignan", "Autre"],
                        // labels : [DateTime.now().plus(0).toJSDate(),
                        //             DateTime.now().plus(1).toJSDate(),
                        //             DateTime.now().plus(2).toJSDate(),
                        //             DateTime.now().plus(3).toJSDate(),
                        //             DateTime.now().plus(4).toJSDate(),
                        //             DateTime.now().plus(5).toJSDate(),
                        //             DateTime.now().plus(6).toJSDate(),
                        //             DateTime.now().plus(7).toJSDate(),
                        //             DateTime.now().plus(8).toJSDate(),
                        //             DateTime.now().plus(9).toJSDate(),
                        //             DateTime.now().plus(10).toJSDate()
                        // ],

                        // datasets: [
                        //     {
                        //     data: [30, 40, 60, 70, 5],
                        //     backgroundColor: [
                        //         "#77CEFF",
                        //         "#0079AF",
                        //         "#123E6B",
                        //         "#97B0C4",
                        //         "#A5C8ED",
                        //     ],
                        //     // backgroundColor: "#0079AF"
                        //     },, .3
                        // ],

                        datasets: [
                            {
                                label : 'Q1',
                                borderColor : '#4f7aa7',
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },
                                
                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'crimson') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q2A',
                                borderColor : '#9fcbe8',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'coral') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q2B',
                                borderColor : '#f28f2a',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'gold') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q3A',
                                borderColor : '#ffbe7e',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'mediumslateblue') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q3B',
                                borderColor : '#58a14f',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'seagreen') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q4A',
                                borderColor : '#8cd17e',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q4B',
                                borderColor : '#b5992c',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q5',
                                borderColor : '#f0ce63',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q6A',
                                borderColor : '#489993',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q6B',
                                borderColor : '#85bcb6',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q6C',
                                borderColor : '#e2575a',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            },
                            {
                                label : 'Q7',
                                borderColor : '#ff9e9b',
                                // fill : true,
                                fill : {
                                    target: 'origin',
                                    above: 'rgb(200, 200, 200, .3)',   // Area will be red above the origin
                                    //below: 'rgb(0, 0, 255)'    // And blue below the origin
                                },

                                pointBorderColor : (context) => { return this.pointBorderColor(context, 'orchid') },
                                pointStyle : this.pointStyle,
                                pointRadius : this.pointRadius,

                                cubicInterpolationMode: 'monotone',
                                data:[]
                            }
                        ],
                    },
                    options: {
                        
                        // scales: {
                        //     y: {
                        //         beginAtZero: true,
                        //     },
                        // },

                        scales: {
                            // adapters: {
                            //     date: {
                            //         // locale: enUS
                            //     }
                            // },

                            x: {
                                type: 'time',
                                time: {
                                  // Luxon format string
                                  tooltipFormat: 'DD T',
                                    // unit: 'day'

                                },
                                title: {
                                    display: true,
                                    text: 'Date'
                                },
                                ticks: {
                                    // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                                    callback: function(val, index) {
                                        // Hide every 2nd tick label
                                        // console.log(">>>>>", val)

                                        return index % 2 === 0 ? val : '';
                                    },
                                    color: 'red',
                                }

                            },
                            y: {
                                title: {
                                    display: true,
                                    text: 'Score'
                                },
                                ticks: {
                                    // For a category axis, the val is the index so the lookup via getLabelForValue is needed
                                    callback: function(val, index) {
                                        index
                                        // QoL scores range from 1 to 5, but we show a chart from 0 to 6 so the
                                        // results are not shown to the edge, but 0 and 6 are not valid results
                                        // so we exclude all non-real results from showing in the axis tick mark values.
                                        return val >= 1 && val <= 5 ? val : '';
                                    },
                                    color: 'red',
                                },

                                // fix the score axis to a min/max so all charts are shown in context of what the
                                // valid ranges can be. QoL ranges from 1 to 5, but we use a min/max of 0 and 6
                                // to allow the chart to have padding when viewing results so results are not 
                                // to the edge of the chart to be visually better.
                                min : 0,
                                max : 6,
                            }
                        },

                        plugins: {
                            title: {
                                text: 'QoL over Time',
                                display: false,
                                position : 'top'
                            },

                            legend : {
                                display: false
                            },

                            zoom: {
                                zoom: {
                                    wheel: {
                                      enabled: true,
                                    },
                                    pinch: {
                                      enabled: true,
                                    },
                                    mode: "xy",
                                },
                            },
                        },
                    },
                    width: 300,
                    height: 150
                },




            }
        },

    filters: {

    },
    
    computed: {

        qolQ1ChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[0])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q1'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ2AChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[1])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q2a'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ2BChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[2])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q2b'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ3AChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[3])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q3a'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ3BChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[4])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q3b'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ4AChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[5])]
            // hit1Data.options.scales.x.title.display = false
            // hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q4a'
            hit1Data.height = 150

            return hit1Data
        },

        qolQ4BChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[6])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q4b'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ5ChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[7])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q5'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ6AChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[8])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q6a'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ6BChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[9])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q6b'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ6CChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[10])]
            hit1Data.options.scales.x.title.display = false
            hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q6c'
            hit1Data.height = 100

            return hit1Data
        },

        qolQ7ChartData() {
            var hit1Data = _.cloneDeep(this.barChartProps2)

            hit1Data.chartData.datasets = [_.cloneDeep(this.barChartProps2.chartData.datasets[11])]
            // hit1Data.options.scales.x.title.display = false
            // hit1Data.options.scales.x.ticks.callback = (val, index) => { index == 0 ? val : '' }
            hit1Data.options.scales.y.title.text = 'Q7'
            hit1Data.height = 150

            return hit1Data
        },

    },
    methods: {
        // ====================================
        // CancasJS Scriptable Callback Helpers
        // ====================================
        pointBorderColor(context, defaultColor) {
            var index = context.dataIndex;
            var entryData = context.dataset.data[index]

            if (entryData == undefined) return defaultColor

            var source = context.dataset.data[index].source;
            return source == 2 /* patient */ ? defaultColor : 'black';
        },
        
        pointStyle(context) {
            var index = context.dataIndex;
            var entryData = context.dataset.data[index]

            if (entryData == undefined) return 'circle'

            var source = context.dataset.data[index].source;
            var value = context.dataset.data[index].y;
            return source == 2 /* patient */
                        ? 'circle'
                        : ( value == MAGIC_NULL_VAL /* mapped from null */ ? 'crossRot' : 'triangle');
        },

        pointRadius(context) {
            var index = context.dataIndex;
            var entryData = context.dataset.data[index]

            if (entryData == undefined) return 3

            var source = context.dataset.data[index].source;
            return source == 2 /* patient */ ? 3 : 8;
        },



        // ====================================

        shuffleData2() {
            // this.barChartProps2.chartData.datasets[0].data = shuffle(this.barChartProps2.chartData.datasets[0].data)
        },

        visibilityChanged (isVisible, entry) {
            entry
            
            if (isVisible == true) {
                // AnalyticsMgr.sendPageView('/Superuser/SponsorManagement');
    
                if (this.toLoadOnShowUI_patientID != null) {
                    console.log("QoL re-load data for patientID", this.toLoadOnShowUI_patientID)
                    this.refreshDataForUI()
                    this.toLoadOnShowUI_patientID = null
                }
            }
        },

        refreshDataForUI() {

            // this.handleLoadEntriesListToNthPage(1)
            
            this.barChartProps2.chartData.datasets[0].data = []
            this.barChartProps2.chartData.datasets[1].data = []
            this.barChartProps2.chartData.datasets[2].data = []
            this.barChartProps2.chartData.datasets[3].data = []
            this.barChartProps2.chartData.datasets[4].data = []
            this.barChartProps2.chartData.datasets[5].data = []
            this.barChartProps2.chartData.datasets[6].data = []
            this.barChartProps2.chartData.datasets[7].data = []
            this.barChartProps2.chartData.datasets[8].data = []
            this.barChartProps2.chartData.datasets[9].data = []
            this.barChartProps2.chartData.datasets[10].data = []
            this.barChartProps2.chartData.datasets[11].data = []

            itBnTx.getPatientFeedbackInsights({inPatientID : this.patientID,
                                                inStartDate : null /* format "YYYY-MM-DD" */,
                                                inEndDate : null /* format "YYYY-MM-DD" */,
                                                inType : 1 /* 1 = QoL, 2 = HIT6 */})
                    .then(response => {
                        this.rawData = response.data
                        
                        this.rawData.data.map((entry) => {
                            var v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q1" ? true : false) })[0].answer;
                        
                            this.barChartProps2.chartData.datasets[0].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q2a" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[1].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q2b" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[2].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q3a" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[3].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q3b" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[4].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q4a" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[5].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q4b" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[6].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q5" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[7].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q6a" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[8].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q6b" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[9].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q6c" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[10].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                            v = entry.choiceAnswers.filter((result) => { return (result.identifier == "q7" ? true : false) })[0].answer;
                            this.barChartProps2.chartData.datasets[11].data.push({source : entry.source, x : entry.timestamp, y: (v != null ? v : MAGIC_NULL_VAL) })
                        })

                        var myChartData = [
  {
    "created_at": "2023-04-01T14:15:22Z",
    "end": "2023-04-01T14:15:22Z",
    "start": "2023-04-01T14:15:22Z",
    "time_zone": {
      "abbreviation": "AEST",
      "identifier": "Australia/Sydney",
      "seconds_from_gmt": 36000,
      "data_version": "2022a"
    },
    "updated_at": "2023-04-01T14:15:22Z",
    "kind": "survey",
    "subkind": "MIS",
    "responses": {
      "1a": 4,
      "1b": 8,
      "2a": 4,
      "2b": 3,
      "2c": 5,
      "3": 12
    }
  },
  {
    "created_at": "2023-04-02T14:15:22Z",
    "end": "2023-04-02T14:15:22Z",
    "start": "2023-04-02T14:15:22Z",
    "time_zone": {
      "abbreviation": "AEST",
      "identifier": "Australia/Sydney",
      "seconds_from_gmt": 36000,
      "data_version": "2022a"
    },
    "updated_at": "2023-04-02T14:15:22Z",
    "kind": "survey",
    "subkind": "MIS",
    "responses": {
      "1a": 5,
      "1b": 7,
      "2a": 3,
      "2b": 2,
      "2c": 4,
      "3": 11
    }
  },
  {
    "created_at": "2023-04-03T14:15:22Z",
    "end": "2023-04-03T14:15:22Z",
    "start": "2023-04-03T14:15:22Z",
    "time_zone": {
      "abbreviation": "AEST",
      "identifier": "Australia/Sydney",
      "seconds_from_gmt": 36000,
      "data_version": "2022a"
    },
    "updated_at": "2023-04-03T14:15:22Z",
    "kind": "survey",
    "subkind": "MIS",
    "responses": {
      "1a": 2,
      "1b": 6,
      "2a": 5,
      "2b": 3,
      "2c": 5,
      "3": 14
    }
  }
]

this.chartOptions.xaxis.categories = []
this.series[0].data = []


  myChartData.map((entry) => {
    this.chartOptions.xaxis.categories.push(entry.start)
    this.series[0].data.push(entry.responses['1a'] + entry.responses['1b'] + entry.responses['2b'] + entry.responses['2c'] + entry.responses['3'])
  })

this.$refs.mychart.refresh()
                    })

        },
        
       

    },

    watch : {
    // "propertyLevel1", "propertyLevel1.propertyLevel2"...
    
        "patientID" (newValue, oldValue) { oldValue; /* console.log("NEW PATIENT_ID - QoL", newValue);*/ this.toLoadOnShowUI_patientID = newValue }

    }

}

/*
  debugging css:

  style="border: 2px solid red;"

*/
</script>

<style scoped>
  

</style>

